var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,256c0-113.7,170.7-113.7,170.7,0C426.7,369.8,256,369.8,256,256z M85.3,426.7c0-47.2,38.2-85.3,85.3-85.3H256v85.3 C256,540.4,85.3,540.4,85.3,426.7L85.3,426.7z M256,0v170.7h85.3c113.8,0,113.8-170.7,0-170.7H256z M85.3,85.3 c0,47.2,38.2,85.3,85.3,85.3H256V0h-85.3C123.5,0,85.3,38.2,85.3,85.3L85.3,85.3z M85.3,256c0,47.2,38.2,85.3,85.3,85.3H256V170.7 h-85.3C123.5,170.7,85.3,208.8,85.3,256L85.3,256z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.6d012b6ff0f976057a01f1475b2cd507.svg";
export { ForwardRef as ReactComponent };